"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormTextInput from "./webflow_modules/Form/components/FormTextInput";
import { AdvSearchNoResults } from "./AdvSearchNoResults";
import { AdvSearchSearchInputDropDownItem } from "./AdvSearchSearchInputDropDownItem";
import { AdvSearchSearchInputViewAllLocations } from "./AdvSearchSearchInputViewAllLocations";
import { SearchInputClearButton } from "./SearchInputClearButton";
import { SearchInputSearchButton } from "./SearchInputSearchButton";

export function AdvSearchSearchInput({
  children,
  clearSearchProps = {},
  searchInputProps = {},
  showClearButton = true,
  showList = true,
}) {
  return (
    <Block className={"div-block-84"} tag={"div"}>
      <Block className={" adv-search-lable"} tag={"div"}>
        {"Location"}
      </Block>
      <Block className={"search-thin-component-copy"} tag={"div"}>
        <Block className={"div-block-107"} tag={"div"}>
          <SearchInputSearchButton />
        </Block>
        <FormTextInput
          autoFocus={false}
          className={"text-field thin"}
          data-name={"Field 4"}
          disabled={false}
          id={"field-4"}
          maxLength={256}
          name={"field-4"}
          placeholder={"Search locations 123456"}
          required={true}
          type={"text"}
          {...searchInputProps}
        />
        <Block className={"div-block-108"} tag={"div"}>
          <SearchInputClearButton
            clearSearchProps={{
              ...clearSearchProps,
            }}
            showClearButton={showClearButton}
          />
        </Block>
        {showList ? (
          <Block className={"div-block-45-copy thin"} tag={"div"}>
            <Block className={"search-frame-popover thin"} tag={"div"}>
              {children ?? (
                <>
                  <AdvSearchSearchInputDropDownItem
                    text={"Market Name market name market name market name"}
                  />
                  <AdvSearchNoResults />
                  <AdvSearchSearchInputViewAllLocations />
                </>
              )}
            </Block>
          </Block>
        ) : null}
      </Block>
    </Block>
  );
}
